import $http from "../../axios";
import { Notification, MessageBox } from "element-ui";

const baseUrl = "/api/medios-magneticos";

function mapParameters(parameters) {
    return parameters.map(p => {
        return {
            value: p.id,
            label: p.name_parameter,
            ...p
        };
    });
}

/**
 * FORMATS
 */
export async function fetchFormats({ commit }) {
    commit("setLoadingTableFormat", true);
    await $http
        .get(`${baseUrl}/formatos`)
        .then(response => {
            commit("setFormats", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
    commit("setLoadingTableFormat", false);
}

export async function createFormat({ dispatch, commit }, data) {
    commit("setLoadingCreateOrUpdateFormat", true);

    await $http
        .post(`${baseUrl}/formatos`, data)
        .then(() => {
            dispatch("fetchFormats");
            commit("resetFormat");
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });

    commit("setLoadingCreateOrUpdateFormat", false);
}

export async function updateFormat({ dispatch, commit }, data) {
    commit("setLoadingCreateOrUpdateFormat", true);

    await $http
        .put(`${baseUrl}/formatos/${data.id}`, data)
        .then(() => {
            dispatch("fetchFormats");
            commit("resetFormat");
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
    commit("setLoadingCreateOrUpdateFormat", false);
}

export async function deleteFormat({ dispatch }, id) {
    await $http
        .delete(`${baseUrl}/formatos/${id}`)
        .then(() => {
            dispatch("fetchFormats");
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

/**
 * CONCEPTS
 */
export async function fetchConcepts({ commit }, format_id) {
    commit("setLoadingTableConcept", true);
    await $http
        .get(`${baseUrl}/conceptos`, { params: { format_id } })
        .then(response => {
            commit("setConcepts", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
    commit("setLoadingTableConcept", false);
}

export async function createConcept({ dispatch, commit, state }, data) {
    commit("setLoadingCreateOrUpdateConcept", true);
    await $http
        .post(`${baseUrl}/conceptos`, data)
        .then(() => {
            dispatch("fetchConcepts", state.magneticMediaFormats.form.id);
            commit("resetConcept");
        })
        .catch(error => {
            console.log("error", error);
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });

    commit("setLoadingCreateOrUpdateConcept", false);
}

export async function updateConcept({ dispatch, commit, state }, data) {
    commit("setLoadingCreateOrUpdateConcept", true);

    await $http
        .put(`${baseUrl}/conceptos/${data.id}`, data)
        .then(() => {
            dispatch("fetchConcepts", state.magneticMediaFormats.form.id);
            commit("resetConcept");
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
    commit("setLoadingCreateOrUpdateConcept", false);
}

export async function deleteConcept({ dispatch, state }, id) {
    await $http
        .delete(`${baseUrl}/conceptos/${id}`)
        .then(() => {
            dispatch("fetchConcepts", state.magneticMediaFormats.form.id);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

/**
 * COLUMNS
 */
export async function fetchColumns({ commit }, concept_id) {
    commit("setLoadingTableColumn", true);
    await $http
        .get(`${baseUrl}/columnas`, { params: { concept_id } })
        .then(response => {
            commit("setColumns", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
    commit("setLoadingTableColumn", false);
}

export async function createColumn({ dispatch, commit, state }, data) {
    commit("setLoadingCreateOrUpdateColumn", true);
    await $http
        .post(`${baseUrl}/columnas`, data)
        .then(() => {
            dispatch("fetchColumns", state.magneticMediaConcepts.form.id);
            commit("resetColumn");
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });

    commit("setLoadingCreateOrUpdateColumn", false);
}

export async function updateColumn({ dispatch, commit, state }, data) {
    commit("setLoadingCreateOrUpdateColumn", true);
    await $http
        .put(`${baseUrl}/columnas/${data.id}`, data)
        .then(() => {
            dispatch("fetchColumns", state.magneticMediaConcepts.form.id);
            commit("resetColumn");
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
    commit("setLoadingCreateOrUpdateColumn", false);
}

export async function deleteColumn({ dispatch, state }, id) {
    await $http
        .delete(`${baseUrl}/columnas/${id}`)
        .then(() => {
            dispatch("fetchColumns", state.magneticMediaConcepts.form.id);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function getVrSelectionOptions({ commit }) {
    await $http
        .get(`${baseUrl}/columnas-vr-selection-options`)
        .then(response => {
            commit("setVrSelectionOptions", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function getRegimeOptions({ dispatch, state, rootState, commit }) {
    let params = {
        codeParamTable: "057",
        paginate: false
    };

    if (!state.magneticMediaColumns.regimeOptions.length) {
        await dispatch("parameters/listParameter", { params }, { root: true });
        commit(
            "setRegimeOptions",
            mapParameters(rootState.parameters.parameters)
        );
    }
}

export async function getContacts({ commit }, filter) {
    await $http
        .get("/api/terceros", { params: { filter } })
        .then(response => {
            commit("setContacts", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

/**
 * RANGE-ACCOUNT
 */
export async function fetchRangeAccounts({ commit }, column_id) {
    commit("setLoadingTableRangeAccount", true);
    await $http
        .get(`${baseUrl}/rango-cuentas`, { params: { column_id } })
        .then(response => {
            commit("setRangeAccounts", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
    commit("setLoadingTableRangeAccount", false);
}

export async function createRangeAccount({ dispatch, commit, state }, data) {
    commit("setLoadingCreateOrUpdateRangeAccount", true);
    await $http
        .post(`${baseUrl}/rango-cuentas`, data)
        .then(() => {
            dispatch("fetchRangeAccounts", state.magneticMediaColumns.form.id);
            commit("resetRangeAccount");
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
    commit("setLoadingCreateOrUpdateRangeAccount", false);
}

export async function updateRangeAccount({ dispatch, commit, state }, data) {
    commit("setLoadingCreateOrUpdateRangeAccount", true);

    await $http
        .put(`${baseUrl}/rango-cuentas/${data.id}`, data)
        .then(() => {
            dispatch("fetchRangeAccounts", state.magneticMediaColumns.form.id);
            commit("resetRangeAccount");
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
    commit("setLoadingCreateOrUpdateRangeAccount", false);
}

export async function deleteRangeAccount({ dispatch, state }, id) {
    await $http
        .delete(`${baseUrl}/rango-cuentas/${id}`)
        .then(() => {
            dispatch("fetchRangeAccounts", state.magneticMediaColumns.form.id);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

/**
 * Reports
 */
export async function fetchGenerateReport({ commit }, data) {
    const params = {
        ...data,
        year: `${data.year}-${data.year2}`,
        year2: undefined
    };

    commit("setLoadingMagneticMediaReport", true);
    await $http
        .get(`${baseUrl}/reportes`, { params })
        .then(response => {
            commit("setMagneticMediaReport", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
    commit("setLoadingMagneticMediaReport", false);
}

export async function getTypesIdent({ dispatch, state, rootState, commit }) {
    let params = {
        codeParamTable: "052",
        paginate: false
    };

    if (!state.magneticMediaReport.typesIdent.length) {
        await dispatch("parameters/listParameter", { params }, { root: true });
        commit("setTypesIdent", mapParameters(rootState.parameters.parameters));
    }
}

export async function updateContact({ commit }, data) {
    // commit("setLoadingMagneticMediaReport", true);
    await $http
        .post(`${baseUrl}/reportes-actualizar-tercero`, data)
        .then(response => {
            commit("setMagneticMediaCurrentEditContact", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
    // commit("setLoadingMagneticMediaReport", false);
}



// WEBPACK FOOTER //
// ./src/modules/magneticMedia/actions.js